(() => {
  const root = document.querySelector('[data-ls-welcome]');
  if (!root) return;

  const excludedPath = /^\/(?:cart|checkouts?|account|policies)(?:\/|$)/i.test(
    window.location.pathname
  );
  if (excludedPath) return;

  const storageGet = (storage, key) => {
    try {
      return storage.getItem(key);
    } catch {
      return null;
    }
  };

  const storageSet = (storage, key, value) => {
    try {
      storage.setItem(key, value);
    } catch {
      // The first-party cookie below remains the fallback when storage is restricted.
    }
  };

  const storageRemove = (storage, key) => {
    try {
      storage.removeItem(key);
    } catch {
      // No action needed when storage is restricted.
    }
  };

  const hasSubscribedCookie = document.cookie
    .split(';')
    .some((item) => item.trim() === 'ls_welcome_subscribed=1');
  const params = new URLSearchParams(window.location.search);
  const forcePreview = params.get('popup_preview') === '1';
  const subscribed = storageGet(window.localStorage, 'ls-welcome-subscribed') === '1' || hasSubscribedCookie;
  const savedState = storageGet(window.sessionStorage, 'ls-welcome-state');
  const panel = root.querySelector('[data-ls-welcome-panel]');
  const minimized = root.querySelector('[data-ls-welcome-minimized]');
  const form = root.querySelector('#ls-welcome-form');
  const email = root.querySelector('[data-ls-welcome-email]');
  const error = root.querySelector('[data-ls-welcome-error]');
  const formView = root.querySelector('[data-ls-welcome-form-view]');
  const success = root.querySelector('[data-ls-welcome-success]');
  const copy = root.querySelector('[data-ls-welcome-copy]');
  const postedSuccessfully =
    root.querySelector('[data-ls-welcome-posted-successfully]')?.value === 'true';

  const setState = (state) => {
    root.dataset.state = state;
    root.hidden = state === 'closed';
    panel.hidden = state !== 'expanded';
    minimized.hidden = state !== 'minimized';
  };

  const markSubscribed = () => {
    storageSet(window.localStorage, 'ls-welcome-subscribed', '1');
    const sharedDomain = /(^|\.)lesevenoptical\.com$/i.test(window.location.hostname)
      ? '; Domain=.lesevenoptical.com'
      : '';
    document.cookie = `ls_welcome_subscribed=1; Max-Age=31536000; Path=/; SameSite=Lax; Secure${sharedDomain}`;
  };

  const closeAfterSuccess = () => {
    setState('closed');
    storageRemove(window.sessionStorage, 'ls-welcome-state');
  };

  root.querySelector('[data-ls-welcome-minimize]')?.addEventListener('click', () => {
    setState('minimized');
    storageSet(window.sessionStorage, 'ls-welcome-state', 'minimized');
  });

  root.querySelector('[data-ls-welcome-expand]')?.addEventListener('click', () => {
    setState('expanded');
    storageSet(window.sessionStorage, 'ls-welcome-state', 'expanded');
  });

  form?.addEventListener('submit', (event) => {
    if (!email.validity.valid) {
      event.preventDefault();
      error.hidden = false;
      email.focus();
      return;
    }

    error.hidden = true;
    storageSet(window.sessionStorage, 'ls-welcome-submit-pending', '1');
  });

  copy?.addEventListener('click', async () => {
    await navigator.clipboard?.writeText('HELLO15');
    copy.textContent = 'Copied';
  });

  if (postedSuccessfully) {
    formView.hidden = true;
    success.hidden = false;
    markSubscribed();
    storageRemove(window.sessionStorage, 'ls-welcome-submit-pending');
    setState('expanded');
    window.setTimeout(closeAfterSuccess, 8000);
  } else if (forcePreview) {
    window.setTimeout(() => setState('expanded'), 250);
  } else if (!subscribed) {
    window.setTimeout(() => setState(savedState === 'minimized' ? 'minimized' : 'expanded'), 6000);
  }
})();
